import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import { Icon } from "../Icons/Svg";
import { Telephone } from "../../BaseComponents/Icons/Svg";
export const TelephoneLinkStyle = styled.a.attrs(({ href }) => ({
	href: `tel:${href}`,
}))`
	margin: ${({ margin }) => (margin ? margin : "5px")};
	color: black !important;
	display: flex;
	align-items: center;
	font-size: 15px;
	svg {
		width: 14.7px;
		height: 16px;
		margin-right: 5px;
	}
	#phone-icon {
		fill: ${({ theme }) => theme.colors.primary};
	}
	&:hover {
		span {
			border-color: transparent;
		}
	}
	span {
		border-bottom: 1px solid black;
		transition: 0.2s ease;
	}
`;

export const TelephoneLink = ({ phone, margin, svg }) => {
	return (
		<TelephoneLinkStyle margin={margin} href={phone} onClick={(e) => {
			e.stopPropagation();
		}}>
			{svg ? <Telephone /> : <Icon margin={'0 5px 0 5px'} className="icon-phone"></Icon>}
			<span>{phone} </span>
		</TelephoneLinkStyle>
	);
};
